export enum UserType {
    SystemAdministrator = 'System Administrator',
    Employee = 'Employee',
    SubcontractorIndividual = 'Subcontractor Individual',
    SubcontractorCompany = 'Subcontractor Company',
    SubcontractorEmployee = 'Subcontractor Employee',
    Subcontractor = 'Subcontractor',
    Client = 'Client',
    LoginContact = 'Login Contact'
}
